import React from 'react';
import { SVGProps } from './types';

function ConnectPlugIcon(props: SVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.042"
        d="M8.618 8.62l1.39-1.391m1.39 4.173l1.392-1.39"
      />
      <path
        stroke="currentColor"
        strokeWidth="1.042"
        d="M14.918 5.13c.36.345.654.79.81 1.353.552 1.98-.39 3.18-.907 3.643l-.933.902-4.919-4.912c1.557-1.554 1.88-1.89 3.458-2.027.605.003 1.702.282 2.491 1.041zm0 0l1.697-1.72M5.146 14.911c.344.36.787.657 1.35.815 1.978.557 3.18-.382 3.644-.898l.903-.93L6.15 8.962c-1.558 1.553-1.895 1.876-2.037 3.454.002.605.277 1.703 1.034 2.495zm0 0L3.42 16.604"
      />
    </svg>
  );
}

export { ConnectPlugIcon };
